import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

function Servizi() {
  const { t } = useTranslation();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": t("serviziPage.titolo"),
    "url": "https://www.andromedaprog.it",
    "serviceType": [
      "Websites",
      "E-commerce",
      "Web Apps",
      "Management Software"
    ],
    "provider": {
      "@type": "Organization",
      "name": "Andromeda Programmazione",
      "url": "https://www.andromedaprog.it"
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("serviziPage.metaTitolo", t("serviziPage.titoloSezione"))} | Andromeda Programmazione</title>
        <meta 
          name="description" 
          content={t("serviziPage.metaDescrizione", "Scopri i servizi offerti da Andromeda Programmazione: siti web, e-commerce, gestionali, microservizi e soluzioni IT personalizzate per aziende e professionisti.")} 
        />
        <meta 
          name="keywords" 
          content="servizi sviluppo web, siti web professionali, e-commerce, web app, software gestionali, microservizi, reti aziendali, consulenza IT Lecce, sviluppo software su misura" 
        />
        <link rel="canonical" href="https://www.andromedaprog.it/servizi" />

        <meta property="og:title" content={t("serviziPage.metaTitolo", t("serviziPage.titoloSezione"))} />
        <meta 
          property="og:description" 
          content={t("serviziPage.metaDescrizione", "Scopri i servizi offerti da Andromeda Programmazione: siti web, e-commerce, gestionali, microservizi e soluzioni IT personalizzate.")} 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.andromedaprog.it/servizi" />
        <meta property="og:image" content="https://www.andromedaprog.it/images/hero-bg.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("serviziPage.metaTitolo", t("serviziPage.titoloSezione"))} />
        <meta 
          name="twitter:description" 
          content={t("serviziPage.metaDescrizione", "Servizi di sviluppo web e software personalizzati per aziende e professionisti.")} 
        />

        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <section id="servizi" className="py-5 text-light bg-dark text-center">
        <h2 className="fw-bold mb-4">{t("serviziPage.titolo")}</h2>
        <p className="lead mb-3">{t("serviziPage.testo")}</p>
      </section>
    </>
  );
}

export default Servizi;
